import { HttpClient } from '@angular/common/http';
import { SearchResourceType } from '@app/core/model/search/search-resource-type';
import { BsApiEndPoints } from '@app/core/services/bs-api/endpoints';
import { SearchResourceDictionaryService } from '@app/core/services/resource-dictionary/search-resource-dictionary.service';
import { DataTableUtilities } from '@app/core/utilities/data-table-utilities';
import { BsshDatePipe } from '@app/core/utilities/pipes/bssh-date.pipe';
import { BiosampleSearchColumnFields, BiosampleSearchGridOptionsFormatter } from '@app/search/gridOptions/biosample-search-grid-options-formatter';
import { OverrideColumnDefinition, OverrideColumnParameters } from '@app/search/gridOptions/search-grid-options-formatter';
import { BiosampleLinkRendererBaseParams, BiosampleLinkRendererComponent } from '@app/shared/cell-renderers/biosample-link-renderer/biosample-link-renderer.component';
import { RadLinkRendererComponent } from '@app/shared/cell-renderers/rad-link-renderer/rad-link-renderer.component';


export class BiosampleChooserGridOptionsFormatter extends BiosampleSearchGridOptionsFormatter {
  constructor(
      public resourceDictionaryService: SearchResourceDictionaryService,
      public bsshDatePipe: BsshDatePipe,
      public http: HttpClient
  ) {
      super(resourceDictionaryService, bsshDatePipe, http);
  }

  protected getOverrideColumnParameters(): OverrideColumnParameters<BiosampleSearchColumnFields> {
      const inclusiveColumns: BiosampleSearchColumnFields[] = [
          BiosampleSearchColumnFields.Name,
          BiosampleSearchColumnFields.DefaultProjectName,
          BiosampleSearchColumnFields.Updated,
          BiosampleSearchColumnFields.LabStatus,
          BiosampleSearchColumnFields.Status
        ];

      const overrideColumnDefinitions: OverrideColumnDefinition<BiosampleSearchColumnFields>[] = [
        {
            headerName: 'Name',
            field: 'BioSample.BioSampleName',
            showAlways: true,
            cellRendererFramework: RadLinkRendererComponent,
            cellRendererParams: (params) => {
                if(params.data) {
                    const biosampleConfig = this.resourceDictionaryService.getResourceConfigByType(SearchResourceType.Biosample);
                    return DataTableUtilities.getRadLinkParams(
                        params.data.BioSample.BioSampleName,
                        biosampleConfig.uiHrefAccessor(params.data),
                        null,
                        null,
                        60
                    );
                } else {
                    return {};
                }
            },
            flex: 3.5,
            minWidth: 250,
            filterActive: false,
            sortable: false,
            colId: BiosampleSearchColumnFields.Name,
        }
      ];

      return {
          inclusiveColumns,
          overrideColumnDefinitions
      };
  }
}
